import React, { FunctionComponent } from 'react';

import { Heropic } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { graphql } from 'gatsby';

import BackdropImage from '../../BackdropImage';
import BreakpointContainer from '../../BreakpointContainer';
import Subtitle from '../../Section/HeroPic/Subtitle';
import Title from '../../Section/HeroPic/Title';
import BlockRenderer from './BlockRenderer';

export const HeroPicFragment = graphql`
  fragment HeroPicFragment on SanityHeroPic {
    title {
      title
      level
    }
    subtitle
    subtitleContent: _rawSubtitleContent
    image {
      alt
      hotspot {
        x
        y
      }
      asset {
        localFile {
          childImageSharp {
            gatsbyImageData(width: 1920, placeholder: BLURRED)
          }
        }
      }
    }
  }
`;

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();
  return {
    root: {
      width: '100%',
      minHeight: spacing(54),
      [breakpoint.up('md')]: {
        minHeight: spacing(64),
      },
    },
    container: {
      width: '100%',
      [breakpoint.up('md')]: {
        padding: spacing(0, 4),
      },
    },
  } as const;
};

const HeroPic: FunctionComponent<Heropic> = (props) => {
  const { image, title, subtitle, subtitleContent } = props;
  const { hotspot, asset, alt } = image || {};

  const classes = useStyles();

  return (
    <BackdropImage
      loading="eager"
      css={classes.root}
      alt={alt}
      aspectRatio={12}
      hotspot={hotspot}
      image={asset.localFile.childImageSharp?.gatsbyImageData}
    >
      <Flex width="100%" justifyContent="center">
        <BreakpointContainer css={classes.container} maxWidth="lg">
          <Title level={title?.level}>{title?.title}</Title>
          {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
          {subtitleContent ? <BlockRenderer blocks={subtitleContent} /> : null}
        </BreakpointContainer>
      </Flex>
    </BackdropImage>
  );
};

export default HeroPic;
